import script from "./View.vue?vue&type=script&setup=true&lang=js"
export * from "./View.vue?vue&type=script&setup=true&lang=js"

import "./View.vue?vue&type=style&index=0&id=1dafd378&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dafd378"]])

export default __exports__